import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { getProduct } from 'services/product.service';

export const getProductQueryKey = 'getProduct';
export const useProduct = (id) => useQuery([getProductQueryKey], () => getProduct(id)
  .then((result: AxiosResponse<Product.Item>) => result.data), {
  refetchOnWindowFocus: false, retry: false, cacheTime: 0,
}) as AxiosResponse<Product.Item, Error>;
